module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Tencent Interactive Live Streaming":"LOP Interactive Live Streaming","roomId":"roomId","RoomId copied successfully":"RoomId copied successfully"},"zh":{"Tencent Interactive Live Streaming":"LOP互动直播","roomId":"房间号","RoomId copied successfully":"房间ID复制成功！"}}')
  delete Component.options._Ctor
}
